<div class="vending-store-container">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="card-title mb-0">
      <span class="lstick"></span>Vending Store Management
    </h4>
    <div>
      <div class="d-flex align-items-center bg-light px-3 py-2 rounded">
        <h5 class="me-2 fw-bold mr-3">
          Charity visible to customer:
        </h5>

        <ui-switch [(ngModel)]="isDonationShowingToUser" [disabled]="isUpdatingDonationVisibility"
          (change)="onDonationVisibilityToggle($event)" [ngModelOptions]="{ standalone: true }"></ui-switch>

        <a href="javascript: void(0);" class="btn btn-primary m-2" placement="top" (click)="viewCouponList(storeData)"
          *ngIf="hasStoreData()">
          View Coupons
        </a>
        <a href="javascript: void(0);" class="btn btn-primary m-2" placement="top" (click)="openCreateStoreModal()">
          {{ hasStoreData() ? "Update Store Info" : "Add Store Info" }}
        </a>
        <a href="javascript: void(0);" class="btn btn-primary m-2" placement="top"
          (click)="openLowStockAlertConfirm(lowStockAlertModal)" *ngIf="hasStoreData()">
          Low Stock Alert
        </a>
      </div>



    </div>
  </div>

  <div *ngIf="!hasStoreData()" class="text-center p-5 bg-light rounded shadow-sm mt-4">
    <i class="fas fa-store-slash fa-3x text-secondary mb-3"></i>
    <h4 class="text-muted">No Store Information</h4>
    <p class="text-secondary">Please add your store info to proceed.</p>
  </div>

  <div class="store-info-panel mb-4" *ngIf="hasStoreData()">
    <h5 class="mb-3">Store Information</h5>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="card mb-4">
          <div class="card-body d-flex align-items-center">
            <div class="icon-container store d-flex align-items-center justify-content-center me-3">
              <i class="fas fa-store" style="font-size: 25px"></i>
            </div>
            <div class="info-container ml-3">
              <h6 class="mb-1">Store Name</h6>
              <p class="mb-0">
                {{ storeData.storeName ? storeData.storeName : "-" }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="card mb-4">
          <div class="card-body d-flex align-items-center">
            <div class="icon-container location d-flex align-items-center justify-content-center me-3">
              <i class="fas fa-map-marker-alt" style="font-size: 25px"></i>
            </div>
            <div class="info-container ml-3">
              <h6 class="mb-1">Store Location</h6>
              <p class="mb-0">
                {{ storeData?.storeLocation ? storeData.storeLocation : "-" }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="card mb-4">
          <div class="card-body d-flex align-items-center">
            <div class="icon-container description d-flex align-items-center justify-content-center me-3">
              <i class="fas fa-info-circle" style="font-size: 25px"></i>
            </div>
            <div class="info-container ml-3">
              <h6 class="mb-1">Store Description</h6>
              <p class="mb-0">
                {{
                storeData.storeDescription ? storeData.storeDescription : "-"
                }}
              </p>
            </div>
          </div>
        </div>
      </div>



      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="card mb-4">
          <div class="card-body d-flex align-items-center">
            <div class="icon-container description d-flex align-items-center justify-content-center me-3">
              <i class="fas fa-clock" style="font-size: 25px"></i>
            </div>

            <div class="info-container ml-3">
              <h6 class="mb-1">Delivery Timing</h6>
              <p class="mb-0">
                {{ storeData.deliveryTiming ? storeData.deliveryTiming : "-" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="card mb-4">
          <div class="card-body d-flex align-items-center">

            <div class="icon-container description d-flex align-items-center justify-content-center me-3">
              <i class="fas fa-tags" style="font-size: 25px"></i>
            </div>

            <div class="info-container ml-3 w-100">
              <h6 class="mb-2">Category</h6>

              <ng-container *ngIf="storeData?.storeCategoryNames?.length > 0; else noCategory">
                <div class="category-badge-container">
                  <span *ngFor="let cat of storeData.storeCategoryNames" class="category-badge">
                    {{ cat }}
                  </span>
                </div>
              </ng-container>

              <ng-template #noCategory>
                <p class="mb-0 text-muted">-</p>
              </ng-template>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="storeData.storeImage">
      <div class="col-8">
        <div class="card mb-4">
          <div class="card-body">
            <h6 class="mb-3">Store Image</h6>
            <img [src]="storeData.storeImage" alt="Store Image" class="img-fluid rounded"
              style="max-height: 200px; object-fit: cover" />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card mb-4">
          <div class="card-body">
            <h6 class="mb-3">Supported Brands</h6>

            <ng-container *ngIf="
                storeData.brand_name && storeData.brand_name.length > 0;
                else noBrand
              ">
              <div class="d-flexflex-wrap">
                <span *ngFor="let brand of storeData.brand_name"
                  class="badge rounded-pill bg-warning px-3 py-2 my-2 mr-2"
                  style="font-size: 0.85rem; font-weight: 500">
                  <i class="fas fa-tag mr-1"></i> {{ brand }}
                </span>
              </div>
            </ng-container>

            <ng-template #noBrand>
              <span class="text-muted fst-italic">No Brand Names Available</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="store-info-panel" *ngIf="hasStoreData()" style="margin-bottom: 10px">
    <div class="d-flex justify-content-between align-items-center mb-3 bg-light">
      <h5 class="mb-0">Store Pricing</h5>
    </div>

    <div class="table-responsive" style="background-color: white">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Min KM</th>
            <th>Max KM</th>
            <th>Price</th>
            <th>VAT (%)</th>
            <th>Exclusive</th>
            <th>Minimum Order Value</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pricing of pricingData; let i = index">
            <td>{{ pricing.min_km }}</td>
            <td>{{ pricing.max_km }}</td>
            <td>{{ currency }} {{ pricing.price }}</td>
            <td>{{ formatVatWithPercentage(pricing.vatPercentage) }}</td>
            <td>
              <span class="badge badge-pill" style="font-size: 15px; min-width: 50px" [ngClass]="
                  pricing.isExclusive ? 'badge-success' : 'badge-secondary'
                ">
                {{ pricing.isExclusive ? "Yes" : "No" }}
              </span>
            </td>
            <td>{{ pricing.min_order_value }}</td>
            <td>
              <a href="javascript: void(0);" class="link mr-2" placement="top" (click)="openCreateStoreModal()"
                ngbTooltip="Edit">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-vending-store-pickup-location></app-vending-store-pickup-location>

  <ng-template #createStoreModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="createStoreLabel">{{ storeModalTitle }}</h5>
      <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
      <div class="store-info-section mb-4">
        <h6 class="mb-3 text-primary">Store Information</h6>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label for="storeNameCreate" class="form-label">Store Name: <span class="text-danger">*</span></label>
              <input type="text" id="storeNameCreate" [(ngModel)]="tempStoreData.storeName" class="form-control"
                [class.validation-error]="validationErrors.storeName" placeholder="Enter store name"
                (input)="validationErrors.storeName = false" />
              <small *ngIf="validationErrors.storeName" class="error-message text-danger">
                Store name is required
              </small>
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="storeDescriptionCreate" class="form-label">Store Description: <span
              class="text-danger">*</span></label>
          <textarea id="storeDescriptionCreate" [(ngModel)]="tempStoreData.storeDescription" class="form-control"
            [class.validation-error]="validationErrors.storeDescription" rows="3" placeholder="Enter store description"
            (input)="validationErrors.storeDescription = false"></textarea>
          <small *ngIf="validationErrors.storeDescription" class="error-message text-danger">
            Store description is required
          </small>
        </div>

        <div class="form-group mb-3">
          <label for="deliveryTimingCreate" class="form-label">
            Delivery Timing: <span class="text-danger">*</span>
          </label>
          <input type="text" id="deliveryTimingCreate" [(ngModel)]="tempStoreData.deliveryTiming" class="form-control"
            [class.validation-error]="validationErrors.deliveryTiming"
            placeholder="Enter delivery timing (e.g. 30-45 mins)" (input)="validationErrors.deliveryTiming = false" />
          <small *ngIf="validationErrors.deliveryTiming" class="error-message text-danger">
            Delivery timing is required
          </small>
        </div>



        <div class="form-group mb-3">
          <label for="countryIsoCodeCreate" class="form-label">
            Country: <span class="text-danger">*</span>
          </label>

          <select id="countryIsoCodeCreate" class="form-control" [(ngModel)]="tempStoreData.countryIsoCode">
            <option value="" disabled>Select Country</option>
            <option *ngFor="let c of allcountry" [value]="c.alpha2Code">
              {{ c.name }} ({{ c.alpha2Code }})
            </option>
          </select>

          <small *ngIf="validationErrors.countryIsoCode" class="error-message text-danger">
            Country is required
          </small>
        </div>
        <div class="form-group mb-3">
          <label class="form-label">
            Category Name(s): <span class="text-danger">*</span>
          </label>

          <div [class.validation-error]="validationErrors.storeCategoryIds">
            <ng-multiselect-dropdown [placeholder]="'Select categories'" [settings]="categoryDropdownSettings"
              [data]="categoryOptions" [(ngModel)]="selectedCategoryItems" [ngModelOptions]="{ standalone: true }"
              (onSelect)="onCategorySelectionChange($event)" (onDeSelect)="onCategoryDeselectionChange($event)"
              (onSelectAll)="onCategorySelectAll($event)" (onDeSelectAll)="onCategoryDeselectAll()">
            </ng-multiselect-dropdown>
          </div>

          <small *ngIf="validationErrors.storeCategoryIds" class="error-message text-danger">
            Please select at least one category
          </small>
        </div>
        <div class="row">
          <!-- Brand Name -->
          <div class="col-12 col-md-6">
            <div class="form-group mb-3">
              <label class="form-label">
                Brand Name(s): <span class="text-danger">*</span>
              </label>

              <div class="rounded p-1" [class.validation-error]="validationErrors.brand_name">
                <div class="form-check" *ngFor="let brand of brandOptions">
                  <input class="form-check-input" type="checkbox" [id]="brand" [value]="brand"
                    (change)="onBrandSelectionChange($event)" [checked]="tempStoreData.brand_name?.includes(brand)" />
                  <label class="form-check-label" [for]="brand">
                    {{ brand }}
                  </label>
                </div>
              </div>

              <small *ngIf="validationErrors.brand_name" class="error-message text-danger">
                Please select at least one brand
              </small>
            </div>
          </div>


        </div>

        <div class="form-group mb-3">
          <label for="storeImageCreate" class="form-label">Store Image:
            <span class="text-danger" *ngIf="!hasStoreData()">*</span></label>
          <input type="file" id="storeImageCreate" class="form-control"
            [class.validation-error]="validationErrors.storeImage" accept="image/*" (change)="onImageSelect($event)" />
          <small *ngIf="validationErrors.storeImage" class="error-message text-danger">
            Store image is required
          </small>
          <div *ngIf="imagePreview" class="mt-2 position-relative">
            <img [src]="imagePreview" alt="Preview" class="img-thumbnail"
              style="max-height: 120px; max-width: 200px; object-fit: cover" />
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="storeLocationCreate" class="form-label">Store Location: <span class="text-danger">*</span></label>
          <input type="text" id="storeLocationCreate" [(ngModel)]="tempStoreData.storeLocation" class="form-control"
            [class.validation-error]="validationErrors.storeLocation" placeholder="Enter store location" readonly />
          <small *ngIf="validationErrors.storeLocation" class="error-message text-danger">
            Store location is required
          </small>
        </div>

        <div class="form-group mb-3">
          <small>Select Store Location on Map: </small>
          <div id="storeLocationMap" style="width: 100%; height: 300px" class="border rounded"
            [class.validation-error]="validationErrors.storeLocation"></div>
          <small class="form-text text-muted">
            Click on the map or search for a location to set your store
            location. You can also drag the marker to adjust the position.
          </small>
        </div>
      </div>

      <hr />

      <div class="pricing-section">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0 text-primary">Price Range</h6>
        </div>

        <div class="pricing-ranges" [class.validation-error]="validationErrors.pricing">
          <small *ngIf="validationErrors.pricing" class="error-message text-danger">
            {{ pricingErrorMessage }}
          </small>
          <div *ngFor="let pricing of tempPricingData; let i = index"
            class="pricing-range-item mb-3 p-3 border rounded">
            <div class="d-flex justify-content-end align-items-center mb-2">
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removePriceRange(i)"
                *ngIf="tempPricingData.length > 1" title="Remove this price range">
                <i class="fas fa-trash"></i>
              </button>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Minimum KM: <span class="text-danger">*</span></label>
                  <input type="number" [(ngModel)]="pricing.min_km" class="form-control" placeholder="Min KM" min="0"
                    step="1" (input)="clearPricingError()" />
                  <small class="text-muted" *ngIf="i === 0">
                    The first range should start at 0 km.
                  </small>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Maximum KM: <span class="text-danger">*</span></label>
                  <input type="number" [(ngModel)]="pricing.max_km" class="form-control" placeholder="Max KM" min="0"
                    step="1" (input)="clearPricingError()" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Price : <span class="text-danger">*</span></label>
                  <input type="number" [(ngModel)]="pricing.price" class="form-control" placeholder="Price" min="0"
                    step="1" (input)="clearPricingError()" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">VAT (%) : <span class="text-danger">*</span></label>
                  <input type="number" [(ngModel)]="pricing.vatPercentage" class="form-control" placeholder="VAT %"
                    min="0" max="100" (input)="clearPricingError()" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Minimum Order Value : <span class="text-danger">*</span></label>
                  <input type="number" [(ngModel)]="pricing.min_order_value" class="form-control"
                    placeholder="Minimum Order Value" min="0" step="1" (input)="clearPricingError()" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Exclusive:</label>
                  <div class="form-check mt-2">
                    <input type="checkbox" class="form-check-input" id="isExclusive_{{ i }}"
                      [(ngModel)]="pricing.isExclusive" (change)="clearPricingError()" />
                    <label class="form-check-label" for="isExclusive_{{ i }}">
                      Is Exclusive
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="my-2">
          <button type="button" class="btn btn-success btn-sm" (click)="addPriceRange()">
            <i class="fas fa-plus"></i> Add Price Range
          </button>
        </div>

        <div *ngIf="tempPricingData.length === 0" class="text-center p-4 bg-light rounded">
          <p class="text-muted mb-2">No pricing ranges added</p>
          <button type="button" class="btn btn-primary btn-sm" (click)="addPriceRange()">
            <i class="fas fa-plus"></i> Add First Price Range
          </button>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeBtnClick()">
        Cancel
      </button>
      <button (click)="saveStoreAndPricing()" class="btn btn-primary" [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ loading ? "Saving..." : "Save Store Information" }}
      </button>
    </div>
  </ng-template>

  <ng-template #lowStockAlertModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Low Stock Alert</h5>
      <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p class="mb-0">Are you sure you want to send the low inventory report?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="confirmSendLowInventoryReport(modal)"
        [disabled]="isSendingLowInventoryReport">
        <span *ngIf="isSendingLowInventoryReport" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ isSendingLowInventoryReport ? "Sending..." : "Confirm" }}
      </button>
    </div>
  </ng-template>
</div>